export default "__VITE_ASSET__9d17e2df__"